import { Model } from 'es6/components/model'
import { Defaults } from 'es-decorators'
import { entryScriptName } from 'init/entry-script-name'

@Defaults({
  urlRoot: `${entryScriptName}/api/v3/search-review`,
})
export class SearchReview extends Model {}
